import React, { useState, useEffect } from "react";
import LoadCSSforfirstTime from "../../../../../CloudStorage/LoadCSSforfirstTime";
import PostedUmbrellaProjects from "./PostedUmbrellaProjects/PostedUmbrellaProjects";
import PostedProjects from "./PostedProjects/PostedProjects";
import PostedContests from "./PostedContests.jsx/PostedContests";
import PostedJobs from "./PostedJobs/PostedJobs";
import AuctionBids from "./AuctionBids/AuctionBids";
import MergersAcquisitions from "./MergersAcquisitions/MergersAcquisitions";
import { useRouteBaseStateContext } from "../../../../../Context/RouteBaseStateContext";

export default function PostedOrders({ postcounts }) {
  const { urlstate, setMyorderPostedordersroute } = useRouteBaseStateContext();

  const path = "Assets/scss/myorders.module.scss";
  const [activeTab, setActiveTab] = useState("PostedOrdersUmbrellaprojects");

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  useEffect(() => {
    if (urlstate?.myorderPostedordersroute) {
      setActiveTab(
        urlstate?.myorderPostedordersroute || "PostedOrdersUmbrellaprojects",
      );
    } else {
      setActiveTab("PostedOrdersUmbrellaprojects");
    }
  }, [urlstate, urlstate?.myorderPostedordersroute]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setMyorderPostedordersroute(tab);
  };

  return (
    <div className ="order-tabs">
      <ul className ="nav nav-tabs mb-3">
        <li className ="nav-item">
          <a
            className ={`nav-link ${activeTab == "PostedOrdersUmbrellaprojects" ? "active" : ""}`}
            onClick={() => handleTabClick("PostedOrdersUmbrellaprojects")}
          >
            Umbrella projects (
            {parseInt(postcounts?.umbrella_project || 0) +
              parseInt(postcounts?.recent_umbrella_project || 0)}
            )
          </a>
        </li>
        <li className ="nav-item">
          <a
            className ={`nav-link ${activeTab == "PostedOrdersProjects" ? "active" : ""}`}
            onClick={() => handleTabClick("PostedOrdersProjects")}
          >
            Post & Browse Projects (PBP) (
            {parseInt(postcounts?.project || 0) + parseInt(postcounts?.recent_project || 0)})
          </a>
        </li>
        <li className ="nav-item">
          <a
            className ={`nav-link ${activeTab == "PostedOrdersContests" ? "active" : ""}`}
            onClick={() => handleTabClick("PostedOrdersContests")}
          >
            Win business Opportunities (WBO) (
            {parseInt(postcounts?.contest || 0) +
              parseInt(postcounts?.payment_pending_contest || 0)}
            )
          </a>
        </li>
        <li className ="nav-item">
          <a
            className ={`nav-link ${activeTab == "PostedOrdersJobs" ? "active" : ""}`}
            onClick={() => handleTabClick("PostedOrdersJobs")}
          >
            Part time Job (PTJ) ({parseInt(postcounts?.job || 0) + parseInt(postcounts?.recent_job || 0)})
          </a>
        </li>
        <li className ="nav-item">
          <a
            className ={`nav-link ${activeTab == "PostedOrdersAuctionbids" ? "active" : ""}`}
            onClick={() => handleTabClick("PostedOrdersAuctionbids")}
          >
            Buy & Sell with Auction (BSA) bids ({parseInt(postcounts?.auction)})
          </a>
        </li>
        <li className ="nav-item">
          <a
            className ={`nav-link ${activeTab == "PostedOrdersMergersAcquisitions" ? "active" : ""}`}
            onClick={() => handleTabClick("PostedOrdersMergersAcquisitions")}
          >
            Merger & Acquisition Services (MAS) ({parseInt(postcounts?.mergers)})
          </a>
        </li>
      </ul>
      <div className ="tab-content">
        {activeTab == "PostedOrdersUmbrellaprojects" && (
          <PostedUmbrellaProjects postcounts={postcounts} />
        )}
        {activeTab == "PostedOrdersProjects" && <PostedProjects />}
        {activeTab == "PostedOrdersContests" && <PostedContests />}
        {activeTab == "PostedOrdersJobs" && <PostedJobs />}
        {activeTab == "PostedOrdersAuctionbids" && <AuctionBids />}
        {activeTab == "PostedOrdersMergersAcquisitions" && (
          <MergersAcquisitions />
        )}
      </div>
    </div>
  );
}
